export default {
  // Header
  'header.temple.name': 'चियोनचुक सियोनवोन',
  'header.temple.english': 'कोरियाई बौद्ध मंदिर',
  'header.menu.introduction': 'परिचय',
  'header.menu.greeting': 'अभिवादन',
  'header.menu.history': 'इतिहास',
  'header.menu.meaning': 'महत्व',
  'header.menu.location': 'स्थान',
  'header.menu.practice': 'अभ्यास',
  'header.menu.pilgrimage': 'तीर्थयात्रा',
  'header.menu.news': 'समाचार',
  'header.menu.resources': 'संसाधन',
  'header.menu.support': 'समर्थन',

  // Hero Section
  'hero.title': 'चियोनचुक सियोनवोन में आपका स्वागत है',
  'hero.subtitle': 'पवित्र स्थल जहां बुद्ध की शिक्षाएं शुरू हुईं, जेतवन, भारत',
  'hero.description': 'चियोनचुक सियोनवोन राजगीर, बिहार, भारत में स्थित एक कोरियाई बौद्ध अभ्यास केंद्र है। हम उस पवित्र स्थल पर ध्यान और अभ्यास का मार्ग चलते हैं जहां बुद्ध ने ज्ञान प्राप्त करने के बाद पहली बार शिक्षा दी थी।',
  'hero.button.visit': 'यात्रा जानकारी',
  'hero.button.learn': 'और जानें',

  // Daily Wisdom
  'wisdom.title': 'दैनिक धम्मपद',
  'wisdom.original': '若以色見我 以音聲求我 是人行邪道 不能見如來',
  'wisdom.korean': '만약 나를 색(형상)으로 보려 하거나, 음성으로 찾으려 한다면, 그 사람은 삿된 길을 가고 있는 것이다. 그는 결코 여래를 볼 수 없다.',
  'wisdom.english': 'If you\'re trying to see me in colour, or in voice, he\'s on a dead path; he can never see the Buddha.',

  // Quick Links
  'links.title': 'त्वरित मार्गदर्शिका',
  'links.visit.title': 'दर्शन समय',
  'links.visit.morning': 'सुबह की प्रार्थना',
  'links.visit.morning.time': '04:00-06:00',
  'links.visit.evening': 'शाम की प्रार्थना',
  'links.visit.evening.time': '18:00-19:00',
  'links.visit.lunch': 'दोपहर का भोजन',
  'links.visit.lunch.time': '12:00-13:00',
  'links.visit.contact': 'यात्रा से पहले संपर्क करें',
  'links.visit.phone': '+91-892-313-9035',
  'links.visit.manager': '(प्रबंधक वर्दान)',
  'links.practice.title': 'अभ्यास कार्यक्रम',
  'links.practice.meditation': 'ध्यान',
  'links.practice.dharma': 'धर्म वार्ता',
  'links.practice.retreat': 'मंदिर प्रवास',
  'links.support.title': 'समर्थन',
  'links.support.regular': 'नियमित दान',
  'links.support.onetime': 'एकमुश्त दान',
  'links.support.volunteer': 'स्वयंसेवक',

  // News Section
  'news.title': 'मंदिर समाचार',
  'news.view': 'विवरण देखें',
  'news.date': 'तारीख',

  // Footer
  'footer.about.title': 'चियोनचुक सियोनवोन के बारे में',
  'footer.about.description': 'चियोनचुक सियोनवोन भारत के राजगीर में स्थित एक कोरियाई बौद्ध अभ्यास केंद्र है, जो बुद्ध का पवित्र स्थल है।',
  'footer.contact.title': 'संपर्क',
  'footer.contact.address': 'राजगीर, बिहार, भारत',
  'footer.contact.phone': 'फोन',
  'footer.contact.email': 'ईमेल',
  'footer.links.title': 'त्वरित लिंक',
  'footer.links.introduction': 'परिचय',
  'footer.links.practice': 'अभ्यास',
  'footer.links.pilgrimage': 'तीर्थयात्रा',
  'footer.links.support': 'समर्थन',
  'footer.hours.title': 'दर्शन समय',
  'footer.hours.morning': 'सुबह: 04:00-06:00',
  'footer.hours.evening': 'शाम: 18:00-19:00',
  'footer.hours.lunch': 'दोपहर का भोजन: 12:00-13:00',
  'footer.copyright': '© 2024 चियोनचुक सियोनवोन। सर्वाधिकार सुरक्षित।',
  'footer.powered': 'वेबसाइट बिल्डर',
};
